import { getDatabase, ref, update }
    from "firebase/database"

export async function setupOneSignal(user) {

    console.log('setupOneSignal user', user)

    if (!user || !user.id) return

    window.OneSignalDeferred =
        window.OneSignalDeferred || []

    window.OneSignalDeferred.push(
        async (OneSignal) => {

            try {

                const permission =
                    OneSignal.Notifications.permission

                console.log(
                    'notification permission',
                    permission
                )

                if (!permission) {

                    await OneSignal
                        .Notifications
                        .requestPermission()

                }

                await OneSignal.login(
                    String(user.id)
                )

                await OneSignal.User.addTag(
                    "role",
                    "admin"
                )

                // IMPORTANT
                const optedIn =
                    OneSignal.User
                        .PushSubscription
                        .optedIn

                const subscriptionId =
                    OneSignal.User
                        .PushSubscription
                        .id

                const token =
                    OneSignal.User
                        .PushSubscription
                        .token

                console.log(
                    'OneSignal optedIn',
                    optedIn
                )

                console.log(
                    'OneSignal subscriptionId',
                    subscriptionId
                )

                console.log(
                    'OneSignal token',
                    token
                )

                if (!subscriptionId) {

                    console.log(
                        'OneSignal not subscribed yet'
                    )

                    return
                }

                const db = getDatabase()

                const userRef = ref(
                    db,
                    'users/' + user.id
                )

                await update(userRef, {

                    oneSignalSubscriptionId:
                    subscriptionId,

                    oneSignalReady: true

                })

                console.log(
                    'OneSignal fully ready'
                )

            } catch (e) {

                console.log(
                    'OneSignal setup error',
                    e
                )

            }

        })

}